@import '../../../globals/main.scss';

pn-proxio-productcard-description {
  h3 {
    font-size: 1.6rem;
  }

  ul {
    padding-left: 2.5rem;
  }

  li {
    font-size: 1.6rem;
    line-height: 2.2rem;
  }

  .highlight {
    color: #0aa85c;
  }
}
